export default __webpack_public_path__ + "static/media/TipIcon.ab648e01.svg";